"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToCollections = exports.SCROLL_TO_HOME_GAMES = void 0;
var react_1 = require("react");
var useCache_1 = require("../useCache");
exports.SCROLL_TO_HOME_GAMES = 'scroll_to_home_games';
var useScrollToCollections = function (ref) {
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    (0, react_1.useEffect)(function () {
        if (!ref || !window)
            return;
        var isScrollable = getDataFromCache(exports.SCROLL_TO_HOME_GAMES);
        setTimeout(function () {
            var _a;
            if (!isScrollable)
                return;
            var topPosition = (((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0) - 60;
            window.scrollTo({
                top: topPosition,
                behavior: 'smooth',
            });
            setDataToCache(exports.SCROLL_TO_HOME_GAMES, null);
        }, 300);
    }, [ref, getDataFromCache, setDataToCache]);
};
exports.useScrollToCollections = useScrollToCollections;
